// document.querySelectorAll(".accordion-item").forEach((item) => {
//   item.querySelector(".accordion-item-header").addEventListener("click", () => {
//     item.classList.toggle("open");
//   });
// });


const accordionItems = document.querySelectorAll(".accordion-item");

accordionItems.forEach((item) => {
  const header = item.querySelector(".accordion-item-header");

  header.addEventListener("click", () => {
    // pehle se jo open accordion hai, use close karo
    const alreadyOpen = document.querySelector(".accordion-item.open");

    if (alreadyOpen && alreadyOpen !== item) {
      alreadyOpen.classList.remove("open");
    }

    // current wale ko toggle karo
    item.classList.toggle("open");
  });
});



$(document).ready(function() {
$('.related-coll-slider').slick({
  dots: true,
  infinite: true,
  loop: true,
  autoplay: true,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});


 
});
$(document).ready(function() {
 $("#cst_quote_btn").click(function(){
    $(".custom-quot-holder").addClass("active");
    
  });
  $(".button-close").click(function(){
    $(".custom-quot-holder").removeClass("active");
    
  });

  });


  let items = document.querySelectorAll(".mega-menu")
  let currentItemIndex

  items.forEach((item, itemIndex) => {
    const content = item.querySelector(".mega-menu__content")
    item.addEventListener("mouseover", () => {
      if (
        (currentItemIndex === 0 && currentItemIndex !== itemIndex) ||
        (currentItemIndex && currentItemIndex !== itemIndex)
      ) {
        items[currentItemIndex].removeAttribute("open")
      }

      currentItemIndex = itemIndex
      item.setAttribute("open", true)
    })

    item.addEventListener("mouseleave", () => {
      let close = true
      content.addEventListener("mouseover", () => {
        close = false
      })
      setTimeout(1000, () => {
        if (close) item.removeAttribute("open")
      })
    })

    content.addEventListener("mouseleave", () => {
      item.removeAttribute("open")
    })
  });


